<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('application_management.complain_recommendation') + ' ' + $t('globalTrans.list') }}</h4>
          </template>
            <template v-slot:headerAction>
                <b-button variant="primary" v-b-modal.modal-5 @click="resetId">
                    {{  $t('globalTrans.add_new') }}
                </b-button>
            </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      <!--  {{data.item}}-->
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                      <template v-slot:cell(trainee.contact_no)="data">
                          {{$n(data.item.trainee.contact_no, {useGrouping: false})}}
                      </template>
                      <template v-slot:cell(training)="data">
                          {{$n(data.item.trainee.contact_no, {useGrouping: false})}}
                      </template>
                      <template v-slot:cell(created_at)="data">
                          {{data.item.created_at | dateFormat}}
                      </template>
                      <template v-slot:cell(complain)="data">
                          {{data.item.complain | truncate(50, '...')}}
                      </template>
                      <template v-slot:cell(trainee.photo)="data">
                          <img style="width: 50px; height: 50px; border-radius: 50%" :src="trainingElearningServiceBaseUrl + 'download-attachment?file=uploads/trainee/profile/'+data.item.trainee.photo" alt="">
                      </template>
                     <template v-slot:cell(status)="data">
                        <span class="badge badge-danger" v-if="data.item.status === 1">{{ $t('globalTrans.on_process') }} </span>
                        <span class="badge badge-success" v-else>{{$t('application_management.resolved')}}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div style="width: 100px">
                          <button title="View" class="btn btn-sm btn-primary mr-2" v-b-modal.modal-4 @click="view(data.item)"><i class="fas fa-eye"></i></button>
                     </div>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="lg" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :items="editItemId"/>
    </b-modal>
      <b-modal id="modal-5" size="lg" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Form :items="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>

import Details from './Details'
import Form from './Form'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { UserComplainListApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
     Details, Form
  },
  data () {
    return {
        trainingElearningServiceBaseUrl: trainingElearningServiceBaseUrl,
      search: {
        circular_memo_no: '',
        training_title_id: 0,
        batch_id: 0
      },
      editItemId: 0,
      viewitemId: 0,
      rows: [],
      officeTypeList: [],
      officeList: []
    }
  },
  computed: {
    formTitle () {
      return (this.editItemId === 0) ? this.$t('application_management.complain_recommendation') + ' ' + this.$t('globalTrans.add') : this.$t('application_management.complain_recommendation') + ' ' + this.$t('globalTrans.modify')
    },
    currentLocale () {
      return this.$i18n.locale
    },
    trainingNameList: function () {
      return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1)
    },
    batchList: function () {
      return this.$store.state.TrainingElearning.commonObj.batchList.filter(item => item.status === 1)
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('globalTrans.date'), class: 'text-center' },
          { label: this.$t('application_management.complain_recommendation'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
            { key: 'created_at' },
            { key: 'complain' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
            { key: 'created_at' },
            { key: 'complain' },
          { key: 'status' },
          { key: 'action' }
        ]
      }
      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
  },
  created () {
      this.loadData()
  },
  mounted () {
  },
  methods: {
    action (edititem) {
      this.editItemId = edititem
    },
      view (edititem) {
          this.editItemId = edititem
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(trainingElearningServiceBaseUrl, UserComplainListApi).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', response.data.data)
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    trainingName (trainingTitleId) {
      const trainingName = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingTitleId)
      if (this.$i18n.locale === 'bn') {
        return trainingName.text_bn
      } else {
        return trainingName.text_en
      }
    }
  }
}
</script>
